import { render } from "./BuIdentifyPlan.vue?vue&type=template&id=0f6354da&scoped=true"
import script from "./BuIdentifyPlan.vue?vue&type=script&lang=js"
export * from "./BuIdentifyPlan.vue?vue&type=script&lang=js"

import "./BuIdentifyPlan.vue?vue&type=style&index=0&id=0f6354da&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6354da"]])

export default __exports__